// @generated by protoc-gen-es v1.3.3 with parameter "target=js,import_extension=none"
// @generated from file msh/common/v1/capture_mode.proto (package msh.common.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * *
 * Capture mode in Datastore
 *
 * @generated from enum msh.common.v1.CaptureMode
 */
export const CaptureMode = proto3.makeEnum(
  "msh.common.v1.CaptureMode",
  [
    {no: 0, name: "CAPTURE_MODE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "CAPTURE_MODE_BATCHED", localName: "BATCHED"},
    {no: 2, name: "CAPTURE_MODE_STREAMED", localName: "STREAMED"},
    {no: 3, name: "CAPTURE_MODE_TEST_COVERAGE", localName: "TEST_COVERAGE"},
  ],
);

